import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { userSelector } from "../../slices/userSlice";
import { UserName } from "components/common/UserName";
import { Nav } from "reactstrap";
import { cdn } from "constants/common";
var ps;
let userSlice;
function Sidebar(props) {
  const { t } = useTranslation();
  const location = useLocation();
  const sidebar = React.useRef();
  const requestsRef = React.useRef(null);
  // const activeRoute = (routeName) => {
  //   const pathSegments = location.pathname.split('/').filter(segment => segment);
  //   return "/" + pathSegments[pathSegments.length - 1] === routeName ? 'active' : "";
  // };
  const activeRoute = (routeName) => {
    return location.pathname === routeName || location.pathname.startsWith(routeName + "/") ? 'active' : "";
  };
  const mainRoutes = props.routes;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector(userSelector);

  const handleNavLinkClick = () => {
    if (window.innerWidth <= 991) {
      props.toggleSidebar();
    }
  };

  useEffect(() => {
    userSlice = require("../../slices/userSlice")
  }, [])

  const handleLogout = () => {
    navigate('/login', { replace: true });
    dispatch(userSlice.logout());
  };

  useEffect(() => {
    if (location.pathname.includes("appointment-requests") || location.pathname.includes("language-requests")) {
      requestsRef.current?.ariaExpanded == "false" && requestsRef.current.click()
    }
    else {
      requestsRef.current?.ariaExpanded == "true" && requestsRef.current.click()
    }
  }, [location.pathname])

  function IncludesUrl(baseUrl) {
    return props.routes.map(i => (i?.path || '').replace(/^\//, '')).includes(baseUrl);
  }

  const RequestsCollapse = ['appointment-requests', 'language-requests'];
  const isRequestRouteActive = RequestsCollapse.some((section) => location.pathname.includes(section));

  return (
    <>
      <div
        className={`sidebar ${props.isSidebarOpen ? "toggled" : ""}`}
        data-color={props.bgColor}
        data-active-color={props.activeColor}
      >
        <div className="logo">
          <button className="close_side" onClick={props.toggleSidebar}>✕</button>
          <Link to="/" className="simple-text logo-mini">
            <div className="logo-img">
              <img src="/images/logo-nav.png" alt="react-logo" />
              <img src="/images/logo-fill.png" alt="react-logo" />
            </div>
          </Link>
        </div>
        <div className="side_user_row">
          <div className="side_user_image">
            {/* <img src="/images/default-person.png" alt="" /> */}
            <img className="rounded-circle" src={user?.user?.image ? (cdn + user?.user?.image) : '/images/default-person.png'} alt="" />
            
          </div>
          <div className="side_user_title">
            <span>{t("sidebar.welcome", { defaultValue: "Welcome," })}</span>
            <UserName name={user?.user?.name} lastName={user?.user?.last_name} />
          </div>
        </div>
        <div className="sidebar-wrapper" ref={sidebar}>
          <Nav>
            {/* Main Section */}
            <li><p className="nav_head">{t("sidebar.general", { defaultValue: "General" })}</p></li>

            {mainRoutes.map((prop, key) => (
              <React.Fragment key={key}>
                {!prop?.subRoute && (
                  <li
                    className={
                      activeRoute(prop.path) + (prop.pro ? " active-pro" : "")
                    }
                  >
                    <NavLink
                      to={prop.layout + prop.path}
                      // className="nav-NavLink"
                      className={({ isActive }) => "nav-NavLink" + (isActive ? " active" : "")}
                      onClick={handleNavLinkClick}
                    >
                      <div className="line_wrap">
                        <img src={prop.icon} alt="side" />
                        <img src={prop.iconActive} alt="side" />
                        <h2>{prop.titleKey ? t(prop.titleKey) : (typeof prop.title === 'string' ? t(prop.title, { defaultValue: prop.title }) : prop.title)}</h2>
                      </div>
                    </NavLink>
                  </li>
                )}

                {/* Show Requests after Appointments */}
                {prop.path === "/appointments" &&
                  RequestsCollapse.some(IncludesUrl) && (
                    <li>
                      <div className="accordion border-0">
                        <div className="accordion-item bg-transparent border-0 text-white">
                          <h2 className="accordion-header" id="headingRequests">
                            <button
                              ref={requestsRef}
                              // className="btn_slide accordion-button collapsed shadow-none bg-transparent text-white"
                              className={`btn_slide accordion-button collapsed shadow-none bg-transparent text-white ${isRequestRouteActive ? 'active' : ''}`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseRequests"
                              aria-expanded="false"
                            >
                              <img src="/images/Reports.png" alt="" />
                              {t("sidebar.requests", { defaultValue: "Requests" })}
                            </button>
                          </h2>

                          <div
                            id="collapseRequests"
                            className="accordion-collapse collapse"
                          >
                            <ul className="accordion-body py-0 bg_gray">
                              {RequestsCollapse.map(
                                (section) =>
                                  IncludesUrl(section) && (
                                    <li key={section}>
                                      <NavLink
                                        to={`/user/${section}`}
                                        // className="nav-NavLink"
                                        className={({ isActive }) => "nav-NavLink" + (isActive ? " active" : "")}
                                        onClick={handleNavLinkClick}
                                      >
                                        <div className="line_wrap">
                                          <img src="/images/Reports.png" alt="side" />
                                          <img src="/images/Reports-fill.png" alt="side" />
                                          <h2>
                                            {section === "appointment-requests"
                                              ? t("sidebar.appointmentRequest", { defaultValue: "Appointment Request" })
                                              : t("sidebar.languageRequest", { defaultValue: "Language Request" })}
                                          </h2>
                                        </div>
                                      </NavLink>
                                    </li>
                                  )
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
              </React.Fragment>
            ))}

            {/* {mainRoutes.map((prop, key) => {
              return (
                !prop?.subRoute && <li
                  className={
                    activeRoute(prop.path) + (prop.pro ? " active-pro" : "")
                  }
                  key={key}
                >
                  <NavLink to={prop.layout + prop.path} className="nav-NavLink" onClick={handleNavLinkClick}>
                    <div className="line_wrap">
                      <img src={prop.icon} alt="side" />
                      <img src={prop.iconActive} alt="side" />
                      <h2>{prop.title}</h2>
                    </div>
                  </NavLink>
                </li>
              );
            })} */}

            {/* {RequestsCollapse.some(IncludesUrl) && (
              <li>
                <div className="accordion border-0">
                  <div className="accordion-item bg-transparent border-0 text-white">
                    <h2 className="accordion-header" id="headingRequests">
                      <button ref={requestsRef} className="btn_slide accordion-button collapsed shadow-none bg-transparent text-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapseRequests" aria-expanded="false" aria-controls="collapseRequests">
                        <img src="/images/Reports.png" alt="" />
                        Requests
                      </button>
                    </h2>

                    <div id="collapseRequests" className="accordion-collapse collapse" aria-labelledby="headingRequests">
                      <ul className="accordion-body py-0 bg_gray">
                        {RequestsCollapse.map(
                          section =>
                            IncludesUrl(section) && (
                              <li key={section}>
                                <NavLink to={`/user/${section}`} className="nav-NavLink" onClick={handleNavLinkClick}>
                                  <div className="line_wrap">
                                    <img src="/images/Reports.png" alt="side" />
                                    <img src="/images/Reports-fill.png" alt="side" />
                                    <h2>{section === 'appointment-requests' ? 'Appointment Request' : 'Language Request'}</h2>
                                  </div>
                                </NavLink>
                              </li>
                            )
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            )} */}


            <li>
              <a href="" onClick={handleLogout} className="nav-NavLink p-0" >
                <div className="line_wrap wrap_logout">
                  <img src='/images/LogOut.png' alt="side" />
                  <img src='/images/LogOut-fill.png' alt="side" />
                  <h2>{t("header.logout", { defaultValue: "Log Out" })}</h2>
                </div>
              </a>
            </li>

          </Nav>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
